import { EntityLabel } from './types';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export function searchPhraseValidation(searchPhrase: string): boolean {
  return searchPhrase.length >= 1;
}

export interface SearchPhraseChangeEventDetail {
  searchPhrase: string;
}

export const getSearchPhraseChangeEventName = (
  entityLabel: EntityLabel
): string => `${entityLabel}_SEARCH_PHRASE_CHANGE`;

export function releaseSearchPhraseChangeEvent(
  searchPhrase: string,
  entityLabel: EntityLabel
): void {
  window.dispatchEvent(
    new CustomEvent<SearchPhraseChangeEventDetail>(
      getSearchPhraseChangeEventName(entityLabel),
      { detail: { searchPhrase } }
    )
  );
}

export function saveSearchPhraseInStorage(
  projectId: string,
  entityLabel: EntityLabel,
  searchPhrase: string
): void {
  LocalStorageManager.setSearchPhrase(projectId, entityLabel, searchPhrase);
}

export function getSearchPhraseFromStorage(
  projectId: string,
  entityLabel: EntityLabel
): string {
  return LocalStorageManager.getSearchPhrase(projectId, entityLabel);
}
